import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import {Grid, Typography, withWidth} from '@material-ui/core';
import {isWidthUp, isWidthDown} from '@material-ui/core/withWidth';
import {Fade} from 'react-reveal';

const securityImage1 = '/images/hyperledger-anvil.png';
const securityImage2 = '/images/community-driven-crypto-finance.png';
const securityImage3 = '/images/talk-to-cirs.png';
const styles = theme => ({
  root: {
    padding: theme.spacing.unit * 12,
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing.unit * 8,
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing.unit * 4
    }
  },
  tagLine: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
    color: theme.palette.primary.light,
    paddingBottom: theme.spacing.unit * 2
  },
  image: {
    maxWidth: '100%'
  },
  icon: {
    height: 36,
    width: 36
  },
  description: {
    color: theme.palette.text.secondary,
  },
  bottomDescription: {
    color: theme.palette.text.secondary
  },
  content: {
    paddingTop: theme.spacing.unit * 10
  },
  contentItem: {
    paddingTop: theme.spacing.unit * 4
  }
});

const Blockchain = withStyles(styles)(({classes, width}) => {

  const image1 = (
    <Grid item xs={12} md={6}>
      <Fade right duration={1500} distance="50%">
        <Grid container justify="center">
          <Grid item>
            <img src={securityImage1} alt="HyperLedger ANVIL" className={classes.image}/>
          </Grid>
        </Grid>
      </Fade>
    </Grid>
  );

  const image2 = (
    <Grid item xs={12} md={6}>
      <Fade left duration={1500} distance="50%">
        <Grid container justify="center">
          <Grid item>
            <img src={securityImage2} alt="HyperLedger ANVIL" className={classes.image}/>
          </Grid>
        </Grid>
      </Fade>
    </Grid>
  );

  const image3 = (
    <Grid item xs={12} md={6}>
      <Fade right duration={1500} distance="50%">
        <Grid container justify="center">
          <Grid item>
            <img src={securityImage3} alt="HyperLedger ANVIL" className={classes.image}/>
          </Grid>
        </Grid>
      </Fade>
    </Grid>
  );

  return (
    <div className={classes.root}>
      <Grid container direction="column" justify="center">
        <Grid item>
          <Typography variant="caption" color="secondary" align="center" gutterBottom className={classes.tagLine}>
            Blockchain
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant={isWidthUp('md', width, false) ? 'h3' : 'h4'} align="center" gutterBottom>
            Hyperledger
            <span style={{fontWeight: 'bold'}}> ANVIL</span>
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body2" className={classes.description} align="center">
            Asynchronous Natively Verified Intertrade Ledger (ANVIL)
          </Typography>
        </Grid>
        {/* Security part 1 */}
        <Grid item className={classes.content}>
          <Grid container direction="row" justify="center" alignItems="stretch">
            {isWidthDown('sm', width) && image1}
            <Grid item xs={12} sm={12} md={6} style={{paddingTop: 96}}>
              <Fade left duration={1500} distance="50%">
                <Grid container direction="column" spacing={40} justify="space-around">
                  <Grid item>
                    <Typography variant={isWidthUp('md', width, false) ? 'h4' : 'h5'} align="left" gutterBottom>
                      <span style={{fontWeight: 'bold'}}> Digital, Democratic Capitalism.</span>
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant="body2" className={classes.description}>
                      Hyperledger Anvil is our bespoke blockchain solution wherein, you the user is authenticated
                      through
                      a
                      cryptographic key.
                    </Typography>
                    <Typography variant="body2" className={classes.description}>
                      You can choose to keep your transactions free by synchronizing your web or mobile device with our
                      blockchain.
                    </Typography>
                  </Grid>
                  <Grid container direction="row" className={classes.contentItem}>
                    <Grid item xs={2}>
                      <img src="images/icons/blockchain/web-and-mobile-interface.svg" alt="Icon"
                           className={classes.icon}/>
                    </Grid>
                    <Grid item xs={10}>
                      <Typography variant="h6">Web & Mobile Interface</Typography>
                      <Typography variant="body2" className={classes.bottomDescription}>
                        You can be a part of the network by accessing it through a web or mobile device. Set the storage
                        and
                        processing power you’d like to dedicate to the network.
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container direction="row" className={classes.contentItem}>
                    <Grid item xs={2}>
                      <img src="/images/icons/blockchain/cross-chain-transaction.svg" alt="Icon"
                           className={classes.icon}/>
                    </Grid>
                    <Grid item xs={10}>
                      <Typography variant="h6">Cross chain transactions </Typography>
                      <Typography variant="body2" className={classes.bottomDescription}>
                        ANVIL allows cross chain transactions on the CryptX financial ecosystem. As long as the
                        respective
                        wallet ID’s are registered with us, you can make transactions between Cryptocurrencies like
                        Bitcoin
                        and Ethereum.
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Fade>
            </Grid>
            {isWidthUp('md', width) && image1}
          </Grid>
        </Grid>
        {/* Security part 2 */}
        <Grid item className={classes.content}>
          <Grid container direction="row" justify="space-between" alignItems="center">
            {image2}
            <Grid item xs={12} sm={12} md={6}>
              <Fade right duration={1500} distance="50%">
                <Grid container direction="column" justify="space-between"
                  // style={{paddingLeft: 56}}
                >
                  <Grid item>
                    <Typography variant="caption" color="secondary" gutterBottom className={classes.tagLine}>
                      Community
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant={isWidthUp('md', width, false) ? 'h4' : 'h5'} gutterBottom>
                      Community Driven
                      <span style={{fontWeight: 'bold'}}> Decentralized Finance.</span>
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant="body2" className={classes.description}>
                      We have created a lively community of professionals, hobbyists and students from all over the
                      world
                      on
                      our blog. You are welcome to come onboard as a CryptX Community member to contribute and discuss
                      on
                      or
                      blogging platform.
                    </Typography>
                  </Grid>
                  <Grid container direction="row" className={classes.contentItem}>
                    <Grid item xs={2}>
                      <img src="/images/icons/blockchain/cryptx-financial-blog.svg" alt="Icon"
                           className={classes.icon}/>
                    </Grid>
                    <Grid item xs={10}>
                      <Typography variant="h6">CryptX Financial Blog</Typography>
                      <Typography variant="body2" className={classes.bottomDescription}>
                        Vote and Take part in decision making processes with regard to listings and offerings on the
                        platform. You will be authenticated using ANVIL.
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container direction="row" className={classes.contentItem}>
                    <Grid item xs={2}>
                      <img src="/images/icons/blockchain/cryptx-trader.svg" alt="Icon" className={classes.icon}/>
                    </Grid>
                    <Grid item xs={10}>
                      <Typography variant="h6">CryptX Financial Traders</Typography>
                      <Typography variant="body2" className={classes.bottomDescription}>
                        You can subscribe to a plethora of professional trading and investment portfolios and take part
                        in
                        these hedge funds.
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Fade>
            </Grid>
          </Grid>
        </Grid>
        {/* Security part 3 */}
        <Grid item className={classes.content}>
          <Grid container direction="row" justify="center">
            {isWidthDown('sm', width) && image3}
            <Grid item xs={12} sm={12} md={6}>
              <Fade left duration={1500} distance="50%">
                <Grid container direction="column" justify="space-between">
                  <Grid item>
                    <Typography variant="caption" color="secondary" gutterBottom className={classes.tagLine}>
                      CRIS
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant={isWidthUp('md', width, false) ? 'h4' : 'h5'} align="left" gutterBottom>
                      CryptX Realtime
                      <span style={{fontWeight: 'bold'}}> Intelligence System.</span>
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant="body2" className={classes.description}>
                      CRIS is your AI powered financial assistant. CRIS can constantly analyze your interactions on
                      CryptX
                      Financial to recommend, predict or automate the state of your assets.
                    </Typography>
                  </Grid>
                  <Grid container direction="row" className={classes.contentItem}>
                    <Grid item xs={2}>
                      <img src="/images/icons/blockchain/talk-to-cirs.svg" alt="Icon" className={classes.icon}/>
                    </Grid>
                    <Grid item xs={10}>
                      <Typography variant="h6">Talk to CRIS </Typography>
                      <Typography variant="body2" className={classes.bottomDescription}>
                        CRIS can be programmed using a chat interface to intuitively customize interactions with your
                        assets.
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container direction="row" className={classes.contentItem}>
                    <Grid item xs={2}>
                      <img src="/images/icons/blockchain/authenticate-cirs.svg" alt="Icon" className={classes.icon}/>
                    </Grid>
                    <Grid item xs={10}>
                      <Typography variant="h6">Authenticate CRIS</Typography>
                      <Typography variant="body2" className={classes.bottomDescription}>
                        CRIS uses your authentication key before executing any action. CRIS can be active or passive
                        based
                        on your preference.
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container direction="row" className={classes.contentItem}>
                    <Grid item xs={2}>
                      <img src="/images/icons/blockchain/cirs-support.svg" alt="Icon" className={classes.icon}/>
                    </Grid>
                    <Grid item xs={10}>
                      <Typography variant="h6">CRIS Support</Typography>
                      <Typography variant="body2" className={classes.bottomDescription}>
                        All level 1 Technical support on the platform is controlled by CRIS. FAQ’s, Crypto Finance
                        statements, Account summary and other general queries can be rectified with CRIS without any
                        waiting
                        queues.
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Fade>
            </Grid>
            {isWidthUp('md', width) && image3}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
});

export default withWidth()(Blockchain);
